import { render, staticRenderFns } from "./ValueSwitch.vue?vue&type=template&id=5ba9110c&scoped=true&"
import script from "./ValueSwitch.vue?vue&type=script&lang=js&"
export * from "./ValueSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ValueSwitch.vue?vue&type=style&index=0&id=5ba9110c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9110c",
  null
  
)

export default component.exports